export default __webpack_public_path__ + "static/lootex-marketplace-5e16ee031f10e8549e004ba109523ddf.png";